import { render, staticRenderFns } from "./Analitica.vue?vue&type=template&id=1b7b1f16&"
import script from "./Analitica.vue?vue&type=script&lang=js&"
export * from "./Analitica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports